export default "__VITE_ASSET__DYqZ792v__"